import { Injectable } from '@angular/core';
import { BaseService } from '../../core/base.service';

/**
 * 学期实体（对应 MySQL semester 表）
 */
export interface Semester {
  /** 主键ID */
  id: number;
  /** 学期名称 (如 2025-2026学年第一学期) */
  name: string;
  /** 开始日期 */
  startDate?: string;
  /** 结束日期 */
  endDate?: string;
  /** 排序号 (越小越靠前) */
  sortOrder: number;
  /** 状态: 0=未开始, 1=进行中, 2=已结束 */
  status: number;
  /** 创建人用户ID */
  userId?: number;
  /** 备注 */
  remark?: string;
  /** 创建时间 */
  addTime?: string;
  /** 创建人ID */
  addUserId?: number;
  /** 更新时间 */
  updateTime?: string;
  /** 更新人ID */
  updateUserId?: number;
}

@Injectable({ providedIn: 'root' })
export class SemesterService extends BaseService<Semester> {
  constructor() {
    super('semester');
  }
}
